import { useTranslation } from 'react-i18next'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { Check } from 'lucide-react'

/*
This property is added by default to popovers / overlays with selectAll prop
You can simply add logic to determine what should happen after selecting.

There are scenarios with nested selects where this approach doesn't work. The solution is to
 manually add property created by this function just with different value than 'select-all' and
  handle it within foo passed as addSelectedValue.

 if (val === customVal) {
  do something
 }

*/
export default function useSelectAllProperty(customVal?: string): PopoverProperty {
  const { t } = useTranslation()
  const selectAllProperty: PopoverProperty = {
    label: t('common.selectAll'),
    value: customVal ?? 'select-all',
    icon: <Check className={`size-4`} />,
  }

  return selectAllProperty
}
